import { createStore } from 'vuex'
import contact from './modules/contact'

export default createStore({
  state: {
    loading: false,
    isDrawerOpen: false,
    loadingMesage: 'carregando.. aguarde!'
  },
  getters: {
  },
  mutations: {
    CHANGE_LOADING (state, status, msg = 'carregando.. aguarde!') {
      state.loading = status
      state.loadingMesage = msg
    },
    IS_DRAWER_OPEN(state) {
      state.isDrawerOpen = !state.isDrawerOpen;
    },
  },
  actions: {
  },
  modules: {
    contact
  }
})
